import React, { useEffect, useState } from "react";
import { getCities, getStates } from "../database/APIcall";
import SelectData from "./SelectFromData";
import { Row } from "react-bootstrap";

const AddressForm = (props) => {
  const { formik } = props;
  const { values } = formik;
  const { country, address } = values;
  const { state } = address;

  const stateobj = {
    id: "",
    name: "Select States",
    country_id: "",
  };

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  useEffect(() => {
    getStates(country).then((res) => {
      setStates(res);
    });
  }, [country]);

  useEffect(() => {
    getCities(state).then((res) => {
      console.log("cities", res);
      setCities(res);
    });
  }, [state]);

  return (
    <div>
      <Row className="mt-3">
        <SelectData
          label="Select States"
          name="address.state"
          options={states}
        />
      </Row>
      <Row className="mt-3">
        <SelectData
          label="Select Cities"
          name="address.city"
          options={cities}
        />
      </Row>
    </div>
  );
};

export default AddressForm;
